module.exports = __webpack_public_path__ + "static/media/kk.a65e4a36.svg";